// extracted by mini-css-extract-plugin
export default {"sectionHeader":"sectionHeader"};